import { Hsluv as HsluvConvertor } from "hsluv";
const conv = new HsluvConvertor();
const convertRgbToHsluv = (color) => {
    conv.rgb_r = color.r;
    conv.rgb_g = color.g;
    conv.rgb_b = color.b;
    conv.rgbToHsluv();
    return { h: conv.hsluv_h, s: conv.hsluv_s / 100, l: conv.hsluv_l / 100, alpha: color.alpha, mode: 'hsluv' };
};
export default convertRgbToHsluv;
